

$('#show_server_bill').on('mouseup', function (e) {
    e.preventDefault();
    if (server_bill) {
        const win = window.open("","_blank");
        let html = '';

        html += '<html>';
        html += '<body style="margin:0!important">';
        html += '<embed width="100%" height="100%" src="data:application/pdf;base64,'+encodeURI(server_bill.file)+'" type="application/pdf" />';
        html += '</body>';
        html += '</html>';

        setTimeout(() => {
            win.document.write(html);
        }, 0);

    }
});

$('#download_server_bill_canceled').click(function (e) {
    e.preventDefault();
    if (server_bill) {
        const linkSource = `data:application/pdf;base64,${encodeURI(server_bill.file)}`;
        const downloadLink = document.createElement("a");
        const fileName = "Arve_"+server_bill.bill_nr+".pdf";

        downloadLink.href = linkSource;
        downloadLink.download = fileName;
        downloadLink.click();
    }
});